<div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">
  <div ng-switch-default>
    <div ng-include="'payment-templates/template-list-overview-other.tpl.html'"></div>
  </div>
  <div ng-switch-when="sl">
    <div ng-include="'payment-templates/template-list-overview-slo.tpl.html'"></div>
  </div>
</div>
